export default __webpack_public_path__ + "img/map-marker-constituent_sites.8b584b03.png";